/* eslint-disable radix */
/* eslint-disable react-hooks/exhaustive-deps */
import { SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Spin
} from 'antd';

import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TIPOS_DOCUMENTO } from '../constants';
import { colores, errorHandler, TIPOS_VEHICULO_MASIVA } from '../utils';
import { instanceRef } from '../utils/axios';
import CustomDatePicker from './CustomDatePicker';
import ResponsiveContainer from './ResponsiveContainer';
import { DescripcionesAsegurado } from './SolicitudView';

const { Option } = Select;

const DescripcionesSolicitudMasiva = ({ idProducto, solicitante }) => {
  switch (idProducto) {
    case 1:
      return <DescripcionesAsegurado solicitante={JSON.parse(solicitante)} />;
    case 7:
      return <DescripcionesAsegurado solicitante={JSON.parse(solicitante)} />;
    default:
      return null;
  }
};

const FormVehiculo = ({
  fields,
  vehiculo,
  setVehiculo,
  name,
  title,
  disabled
}) => {
  const [form] = Form.useForm();
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [submodelos, setSubmodelos] = useState([]);
  const [anios, setAnios] = useState([]);

  async function getMarcas() {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      // error
    }
  }

  async function getModelos() {
    try {
      const marca = !disabled ? vehiculo?.id_marca : fields.id_marca;
      if (marca) {
        const response = await instanceRef.instance.get(
          `data/modelos?marca=${marca}`
        );
        const orderedModelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];
        setModelos(orderedModelos);
      }
    } catch (error) {
      // error
    }
  }

  async function getSubmodelos() {
    try {
      const marca = !disabled ? vehiculo?.id_marca : fields.id_marca;
      const modelo = !disabled ? vehiculo?.id_modelo : fields.id_modelo;

      if (marca && modelo) {
        const response = await instanceRef.instance.get(
          `data/submodelos?marca=${marca}&modelo=${modelo}`
        );
        const orderedSubmodelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];
        setSubmodelos(orderedSubmodelos);
      }
    } catch (error) {
      // error
    }
  }

  async function getAnios() {
    try {
      const marca = !disabled ? vehiculo?.id_marca : fields.id_marca;
      const modelo = !disabled ? vehiculo?.id_modelo : fields.id_modelo;
      const submodelo = !disabled
        ? vehiculo?.id_submodelo
        : fields.id_submodelo;
      if (marca && modelo && submodelo) {
        const response = await instanceRef.instance.get(
          `data/anio?marca=${marca}&modelo=${modelo}&submodelo=${submodelo}`
        );
        const orderedAnios = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (parseInt(a.descripcion) < parseInt(b.descripcion)) {
                return 1;
              }
              if (parseInt(a.descripcion) > parseInt(b.descripcion)) {
                return -1;
              }
              return 0;
            })
          : [];
        setAnios(orderedAnios);
      }
    } catch (error) {
      // error
    }
  }

  useEffect(() => {
    getMarcas();
    getModelos();
    getSubmodelos();
    if (setVehiculo) {
      setVehiculo(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehiculo?.id_marca) {
      getModelos();
    }
  }, [vehiculo?.id_marca]);

  useEffect(() => {
    if (vehiculo?.id_modelo) {
      getSubmodelos();
    }
  }, [vehiculo?.id_modelo]);

  useEffect(() => {
    if (vehiculo?.id_submodelo) {
      getAnios();
    }
  }, [vehiculo?.id_submodelo]);

  const handleFormChange = (value, field) => {
    setVehiculo((fieldsParams) => {
      return { ...fieldsParams, [field]: value };
    });
  };

  return (
    <>
      <Divider>{title}</Divider>
      <br />
      <Form
        name={name}
        scrollToFirstError
        initialValues={fields}
        layout="vertical"
        form={form}
        noValidate
      >
        <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
          <Col xs={24} md={24}>
            <Form.Item label="Tipo" name="tipo" disabled>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                disabled={disabled}
              >
                {Object.keys(TIPOS_VEHICULO_MASIVA).map((key) => (
                  <Option key={key} value={key}>
                    {key}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Marca" name="id_marca">
              <Select
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                onChange={(value) => {
                  handleFormChange(value, 'id_marca');
                  handleFormChange(null, 'id_modelo');
                  handleFormChange(null, 'id_submodelo');
                }}
              >
                {marcas.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Modelo" name="id_modelo">
              <Select
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder={!disabled ? 'Elegir modelo' : ''}
                onChange={(value) => {
                  handleFormChange(value, 'id_modelo');
                  handleFormChange(null, 'id_submodelo');
                  handleFormChange(null, 'anio');
                }}
              >
                {modelos.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Submodelo" name="id_submodelo">
              <Select
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder={!disabled ? 'Elegir submodelo' : ''}
                onChange={(value) => {
                  handleFormChange(value, 'id_submodelo');
                  handleFormChange(null, 'anio');
                }}
              >
                {submodelos.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Año" name="id_aniosubmodelo">
              <Select
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder={!disabled ? 'Elegir año' : ''}
                onChange={(value) => {
                  handleFormChange(value, 'id_aniosubmodelo');
                }}
              >
                {anios.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Color" name="color">
              <Select
                disabled={disabled}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder={!disabled ? 'Elegir color' : ''}
              >
                {colores.map((item, index) => (
                  <Option key={index} value={item.descripcion}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Chassis" name="chassis">
              <Input
                disabled={disabled}
                onChange={(value) => {
                  handleFormChange(value.target.value, 'chassis');
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <Form.Item label="Chapa" name="chapa">
              <Input
                disabled={disabled}
                onChange={(value) => {
                  handleFormChange(value.target.value, 'chapa');
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

const FormPersonal = ({
  fields,
  persona,
  setPersona,
  name,
  title,
  disabled
}) => {
  const [form] = Form.useForm();
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);

  async function getDepartamentos() {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      getDistritos(fields?.id_departamento);
    } catch (error) {
      // error
    }
  }

  async function getDistritos(departamento) {
    try {
      if (departamento) {
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${departamento}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        setDistritos(orderedDistritos);
      }
    } catch (error) {
      // error
    }
  }

  useEffect(() => {
    getDepartamentos();

    if (persona) {
      const personaForm = {
        ...persona,
        tipo_documento: !persona.ruc ? 1 : 3
      };
      setPersona(personaForm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    getDepartamentos();

    if (persona) {
      const personaForm = {
        ...persona,
        tipo_documento: !persona.ruc ? 1 : 3
      };
      setPersona(personaForm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFormChange = (value, field) => {
    setPersona((fieldsParams) => {
      return { ...fieldsParams, [field]: value };
    });
  };

  return (
    <>
      <Divider>{title}</Divider>
      <br />
      <Form
        name={name}
        scrollToFirstError
        initialValues={fields}
        layout="vertical"
        form={form}
        noValidate
      >
        <Row gutter={[16, 0]} style={{ maxWidth: '1200px', margin: 'auto' }}>
          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Nombre y Apellido"
              name="nombres"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <Input
                placeholder="Ingrese un valor"
                disabled={disabled}
                onChange={(value) => {
                  handleFormChange(value.target.value, 'nombres');
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Cédula de Identidad"
              name="cedula"
              rules={[{ required: true, message: 'Requerido' }]}
              onChange={(value) => {
                handleFormChange(value.target.value, 'cedula');
              }}
            >
              <Input
                // onChange={(e) => debounceFormChange(e.target.value)}
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={24} align="start">
            <Form.Item label="RUC (Opcional)" name="ruc">
              <Input
                placeholder="Ej.: 12345678-9"
                onChange={(value) => {
                  handleFormChange(value.target.value, 'ruc');
                }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={24} align="start">
            <Form.Item label="Celular" name="celular" disabled>
              <Input
                mask="(999) 999-999"
                placeholder="(___) ___-___ (OPCIONAL)"
                // addonBefore="+595"
                onChange={(value) =>
                  handleFormChange(value.target.value, 'celular')
                }
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Correo"
              name="correo"
              rules={[
                { required: true, message: 'Requerido' },
                {
                  type: 'email',
                  message: 'El correo no es válido'
                }
              ]}
            >
              <Input
                placeholder="Ingrese un valor"
                type="email"
                onChange={(value) =>
                  handleFormChange(value.target.value, 'correo')
                }
                disabled={disabled}
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={24} align="start">
            <Form.Item label="Departamento" name="id_departamento">
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Elegir departamento"
                onChange={(value) => {
                  handleFormChange(value, 'id_departamento');
                  form.setFieldsValue({
                    id_departamento: value,
                    id_distrito: null
                  });
                  getDistritos(value);
                }}
                disabled={disabled}
              >
                {departamentos.map((item) => {
                  return (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Ciudad"
              name="id_distrito"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Elegir distrito"
                disabled={disabled}
                onChange={(value) => {
                  handleFormChange(value, 'id_distrito');
                  form.setFieldsValue({
                    id_distrito: value
                  });
                }}
              >
                {distritos.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Dirección"
              name="domicilio"
              rules={[{ required: true, message: 'Requerido' }]}
            >
              <Input
                placeholder="Ingrese un valor"
                onChange={(value) =>
                  handleFormChange(value.target.value, 'domicilio')
                }
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24} align="start">
            <Form.Item
              label="Fecha Nacimiento"
              name="fecha_nacimiento_moment"
              rules={[{ required: true }]}
            >
              <CustomDatePicker
                style={{ width: '100%' }}
                placeholder="DD/MM/YYYY"
                format="DD/MM/YYYY"
                onChange={(e) => {
                  handleFormChange(e.format('YYYY-MM-DD'), 'fecha_nacimiento');
                }}
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={24} align="start">
            <Form.Item label="Tipo de Documento" name="tipo_documento">
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
                placeholder="Elegir tipo de documento"
                onChange={(value) => {
                  handleFormChange(value, 'tipo_documento');
                }}
                disabled={disabled}
              >
                {TIPOS_DOCUMENTO.map(({ codigo, descripcion }) => (
                  <Option key={codigo} value={codigo}>
                    {codigo} - {descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};
function SolicitudEdit(props) {
  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState();
  const [motivos, setMotivos] = useState();
  const [vehiculo, setVehiculo] = useState();
  const [persona, setPersona] = useState();
  const history = useHistory();

  const fetch = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(
        `/solicitud/${props.match.params.id}`
      );
      const { data } = response.data;
      setSolicitud(data);

      const responseErrores = await instanceRef.instance.get(
        `error/all/${data.id}`
      );
      if (responseErrores.data.data) {
        setMotivos(responseErrores.data.data);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const aprobarSolicitud = async () => {
    const idProducto = solicitud?.cotizacion?.id_producto;
    const vehiculoToUpdate = vehiculo;
    const personaToUpdate = (idProducto === 2 || idProducto === 7) &&
      persona && {
        ...persona,
        ruc: persona.tipo_documento === 3 ? '088888801-5' : null
      };
    setLoading(true);
    try {
      await instanceRef.instance.post(`solicitud/masiva/${solicitud.token}`, {
        idProducto,
        vehiculo: vehiculoToUpdate,
        persona: personaToUpdate,
        poliza: solicitud?.poliza,
        idAseguradora:
          solicitud?.cotizacion?.aseguradoraEmpresa?.aseguradora?.id,
        sebaotExcel: solicitud?.poliza?.sebaot_excel
      });

      setLoading(false);
      message.success('Actualizado correctamente');
      history.push(`/solicitudes/${solicitud?.token}`);
    } catch (error) {
      setLoading(false);
      errorHandler(error, 'No se pudo actualizar la solicitud');
    }
  };

  const rechazarSolicitud = async () => {
    setLoading(true);
    try {
      await instanceRef.instance.put(`solicitud/estado/${solicitud.token}`, {
        estado: 'RECHAZADO'
      });

      setLoading(false);
      message.success('Actualizado correctamente');
      history.push(`/solicitudes`);
    } catch (error) {
      setLoading(false);
      errorHandler(error, 'No se pudo actualizar la solicitud');
    }
  };

  return (
    <ResponsiveContainer size="large">
      <Card
        title={`Solicitud Nro.: ${solicitud?.id || ''}`}
        style={{ textAlign: 'left' }}
      >
        <Spin spinning={loading} size="large" tip="Cargando...">
          <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
            <Col xs={24} md={16}>
              {solicitud?.tipo === 'MASIVA' && (
                <>
                  <Descriptions
                    title="Datos del lote masivo"
                    style={{ textAlign: 'left', paddingBottom: 40 }}
                    bordered
                    size="small"
                    column={{ md: 2, sm: 1, xs: 1 }}
                  >
                    <Descriptions.Item label="Nro Registro de Lote" span={2}>
                      {solicitud.poliza?.id_registro_excel}
                    </Descriptions.Item>
                    <Descriptions.Item label="Fecha Inicio Vigencia">
                      {solicitud.poliza?.fecha_inicio_vigencia &&
                        moment(
                          solicitud.poliza?.fecha_inicio_vigencia,
                          'YYYY-MM-DD'
                        ).format('DD/MM/YYYY')}
                    </Descriptions.Item>
                    <Descriptions.Item label="Fecha Fin Vigencia">
                      {solicitud.poliza?.fecha_inicio_vigencia &&
                        moment(
                          solicitud.poliza?.fecha_fin_vigencia,
                          'YYYY-MM-DD'
                        ).format('DD/MM/YYYY')}
                    </Descriptions.Item>
                  </Descriptions>
                  <DescripcionesSolicitudMasiva
                    idProducto={solicitud?.cotizacion?.id_producto}
                    solicitante={solicitud?.solicitante}
                  />
                </>
              )}
            </Col>
            <Col xs={24} md={8}>
              <Card title="Motivos de la Solicitud a verificar">
                <ol>
                  {motivos &&
                    motivos.map((item) => (
                      <li key={item.id}>{item.mensaje}</li>
                    ))}
                </ol>
              </Card>
            </Col>
          </Row>
          <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
            <Col xs={24} md={24}>
              {solicitud?.tipo === 'MASIVA' &&
                solicitud?.cotizacion?.id_producto === 1 && (
                  <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                    <Col xs={24} md={8}>
                      <FormVehiculo
                        fields={solicitud?.datos_originales?.vehiculo}
                        disabled
                        name="vehiculoOriginal"
                        title="Datos cargados"
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <FormVehiculo
                        fields={solicitud?.datos_bcp?.vehiculo}
                        disabled
                        name="vehiculoBcp"
                        title="Datos verificados"
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <FormVehiculo
                        fields={solicitud?.cotizacion?.vehiculo}
                        vehiculo={vehiculo}
                        setVehiculo={setVehiculo}
                        disabled={false}
                        name="vehiculoEmision"
                        title="Datos para emisión"
                      />
                    </Col>
                  </Row>
                )}
              {solicitud?.tipo === 'MASIVA' &&
                (solicitud?.cotizacion?.id_producto === 2 ||
                  solicitud?.cotizacion?.id_producto === 7) && (
                  <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                    <Col xs={24} md={8}>
                      <FormPersonal
                        fields={{
                          ...solicitud?.datos_originales?.persona,
                          fecha_nacimiento_moment: moment(
                            solicitud?.datos_originales?.persona
                              ?.fecha_nacimiento,
                            'YYYY-MM-DD'
                          ),
                          tipo_documento: solicitud?.cotizacion?.persona.ruc
                            ? 3
                            : 1
                        }}
                        disabled
                        name="personaOriginal"
                        title="Datos originales"
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <FormPersonal
                        fields={{
                          ...solicitud?.datos_bcp?.persona,
                          fecha_nacimiento_moment: moment(
                            solicitud?.datos_bcp?.persona?.fecha_nacimiento,
                            'YYYY-MM-DD'
                          ),
                          tipo_documento: solicitud?.cotizacion?.persona.ruc
                            ? 3
                            : 1
                        }}
                        disabled
                        name="personaBCP"
                        title="Datos verificados"
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <FormPersonal
                        fields={{
                          ...solicitud?.cotizacion?.persona,
                          fecha_nacimiento_moment: moment(
                            solicitud?.cotizacion?.persona?.fecha_nacimiento,
                            'YYYY-MM-DD'
                          ),
                          tipo_documento: solicitud?.cotizacion?.persona.ruc
                            ? 3
                            : 1,
                          id_departamento:
                            solicitud?.cotizacion?.persona?.departamento.id,
                          id_distrito:
                            solicitud?.cotizacion?.persona?.distrito.id
                        }}
                        persona={solicitud?.cotizacion?.persona}
                        setPersona={setPersona}
                        disabled={false}
                        name="personaEmision"
                        title="Datos para emisión"
                      />
                    </Col>
                  </Row>
                )}
            </Col>
          </Row>
          <br />
          <Space>
            <Button
              type="default"
              style={{
                color: '#ff4d4f',
                borderColor: '#ff4d4f'
              }}
              onClick={rechazarSolicitud}
            >
              Rechazar
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              onClick={aprobarSolicitud}
              icon={<SaveOutlined />}
            >
              Aprobar
            </Button>
          </Space>
        </Spin>
      </Card>
    </ResponsiveContainer>
  );
}

export default SolicitudEdit;
